import { Typography } from '@mui/material/styles/createTypography';
import { useTheme } from '@mui/system';
import { Text } from '@visx/text';
import { toNumber } from 'lodash';
import React from 'react';
import { IWidgetXYTickComponentProps } from 'types/analytics';
import { ITheme } from 'types/theme';
import { analyticsNumericFormat } from '../analytics/utils';

const WidgetYTickComponent: React.FC<IWidgetXYTickComponentProps> = ({
	value
}) => {
	const theme = useTheme<ITheme>();
	const style = {
		...(theme.typography as Typography).subtitle2,
		fontWeight: 200,
		fill: theme.palette.text.secondary
	};

	const numericValue = toNumber(value.replaceAll(',', ''));
	if (numericValue === 0) {
		return <Text />;
	}

	const display = Number.isNaN(numericValue)
		? value
		: analyticsNumericFormat(numericValue);

	return (
		<Text
			style={style}
			x={-20}
			y={5}
			width={20}
			textAnchor="start"
			scaleToFit="shrink-only"
		>
			{display}
		</Text>
	);
};

export default WidgetYTickComponent;
